import * as Yup from 'yup';
import { StepSubjectForm } from './step-subject-types';

export const stepSubjectSchema = () =>
  Yup.object<StepSubjectForm>().shape({
    submission: Yup.object({
      text: Yup.string().required('Povinné pole'),
      attachments: Yup.array()
        .of(Yup.mixed<File>())
        .test(
          'max-files-count-and-no-zip-files',
          // The `${fileNames}` placeholder will be replaced by the parameter from createError
          'Příloha ${fileNames} je ve formátu .zip, který není podporovaným formátem. Pro pokračování přílohu odeberte.',
          function (files) {
            if (!files || files.length === 0) {
              return true;
            }
            // test max items count
            if (files.length > 10) {
              return this.createError({
                message: 'Maximální dovolený počet přiložených souborů je 10.',
              });
            }

            const zipFiles = (files as File[]).filter((file) => {
              if (!file) return false;

              const isZipMimeType =
                file.type === 'application/zip' ||
                file.type === 'application/x-zip-compressed';
              const isZipExtension = file.name.toLowerCase().endsWith('.zip');

              return isZipMimeType || isZipExtension;
            });

            if (zipFiles.length === 0) {
              return true;
            }

            const fileNames = zipFiles
              .map((file) => `"${file.name}"`)
              .join(', ');

            return this.createError({ params: { fileNames } });
          }
        ),
    }),
  });
